import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SavedTuitionSearchesResult from './SavedTuitionSearchesResult'

class SavedTuitionSearchesWrapper extends Component {
  static propTypes = {
    onDelete: PropTypes.func.isRequired,
    tuitionSearches: PropTypes.array.isRequired,
  }

  render() {
    const { onDelete, tuitionSearches } = this.props
    return (
      <div>
        {tuitionSearches.map((item, index) => (
          <SavedTuitionSearchesResult
            key={item._id}
            savedTuitionSearch={item}
            onDelete={onDelete}
          />
        ))}
      </div>
    )
  }
}

export default SavedTuitionSearchesWrapper



// WEBPACK FOOTER //
// ./src/routes/authenticated/Tuition/components/SavedTuitionSearches/SavedTuitionSearchesWrapper.js